import Orcamento from 'models/Orcamento';
import OrcamentoProduto from 'models/OrcamentoProduto';
import Pessoa from 'models/Pessoa';
import { useEffect, useState } from 'react';
import { CardHeader, Col, Row } from 'reactstrap';
import api from 'services/api';
import { IdOrcamentoLabel, RowButtons } from './styles';

function ConfiguracaoDetalhesCabecalho({ orcamentoId, gnf }: any): JSX.Element {
  const [clienteOrcamento, setClienteOrcamento] = useState<Pessoa>(
    {} as Pessoa,
  );

  const [clienteOriginalOrcamento, setClienteOriginalOrcamento] =
    useState<Pessoa>({} as Pessoa);

  const [orcamentoProduto, setOrcamentoProduto] = useState(
    [] as OrcamentoProduto[],
  );

  const [nomeRepresentante, setNomeRepresentante] = useState('');
  const [nomeGerente, setNomeGerente] = useState('');

  const [orcamento, setOrcamento] = useState({} as Orcamento);

  async function getListaRepresentantes() {
    const response = await api.get('/integracao/indicadores-negocio');

    // setListaRepresentantes(response.data);
    if (orcamento.representante) {
      const representanteFormatado = orcamento.representante
        .substring(0, orcamento.representante.indexOf('/'))
        .trim();
      if (representanteFormatado.length > 8) {
        setNomeGerente(
          String(
            response.data.find(
              (indic: any) =>
                indic.razaoRepresentante === representanteFormatado,
            )?.razaoGerente,
          ),
        );

        setNomeRepresentante(
          String(
            response.data.find(
              (indic: any) =>
                indic.razaoRepresentante === representanteFormatado,
            )?.razaoRepresentante,
          ),
        );
      } else {
        setNomeGerente(
          String(
            response.data.find(
              (indic: any) =>
                indic.codigoRepresentante === Number(representanteFormatado),
            )?.razaoGerente,
          ),
        );

        setNomeRepresentante(
          String(
            response.data.find(
              (indic: any) =>
                indic.codigoRepresentante === Number(representanteFormatado),
            )?.razaoRepresentante,
          ),
        );
      }
    }
  }

  async function getOrcamentoVersao(abaAtual?: string) {
    let response;
    try {
      response = await api.get(`/orcamento/versao/${orcamentoId}`, {
        params: { completo: true },
      });
    } catch (error) {
      console.log(error);
    }

    const orc = response?.data;

    const produto = orc?.OrcamentoProduto ?? [];

    setOrcamentoProduto(produto);

    setClienteOrcamento(orc?.orcamento?.pessoa ?? {});
    setClienteOriginalOrcamento(orc?.orcamento?.pessoaGnf ?? {});
  }

  async function carregarOrcamento() {
    const response = await api.get(`/orcamento/${orcamentoId}`);

    setOrcamento(response.data);
  }

  useEffect(() => {
    if (orcamentoId) {
      carregarOrcamento();
      getOrcamentoVersao();
      getListaRepresentantes();
    }
  }, [orcamentoId]);

  function ConfiguracaoDescricao() {
    return (
      <Row className="mt-2">
        <Col sm="4">
          <IdOrcamentoLabel>
            {`Configuração ${orcamentoId}`}
            {gnf ? ` - GNF ${gnf}` : ''}
          </IdOrcamentoLabel>
        </Col>
      </Row>
    );
  }

  function ConfiguracaoDetalhes() {
    return (
      <Row className="ml-2">
        <Col className="order-xl-2">
          <CardHeader className="bg-white border-3">
            <Row className="align-items-center">
              <Col sm="5" xs="6">
                <IdOrcamentoLabel>
                  {`Configuração ${orcamentoId}`}
                  {gnf ? ` - GNF ${gnf}` : ''}
                </IdOrcamentoLabel>
              </Col>
              <Col sm="5" xs="6" className="text-center">
                {clienteOriginalOrcamento.codigoDomsge && (
                  <h4>
                    {clienteOriginalOrcamento.codigoDomsge} -{' '}
                    {clienteOriginalOrcamento.razaoSocial}
                  </h4>
                )}
                {clienteOrcamento.codigoDomsge !==
                  clienteOriginalOrcamento.codigoDomsge && (
                  <h5>
                    {clienteOrcamento.codigoDomsge} -{' '}
                    {clienteOrcamento.razaoSocial}
                  </h5>
                )}
              </Col>
              <Col sm="2" xs="6">
                <div className="text-right">
                  {orcamentoProduto.length && (
                    <h5>{orcamentoProduto[0].nome}</h5>
                  )}
                </div>
              </Col>
            </Row>
            <Row>
              <Col sm="6" xs="6">
                {orcamento.representante && (
                  <h5>
                    Representante / Ger.Negócio: {nomeRepresentante}{' '}
                    {nomeGerente !== null &&
                    nomeGerente !== undefined &&
                    nomeGerente !== 'null'
                      ? ` / ${nomeGerente}`
                      : ''}
                  </h5>
                )}
              </Col>
            </Row>
          </CardHeader>
        </Col>
      </Row>
    );
  }

  return (
    <div>
      {/* <ConfiguracaoDescricao /> */}
      <ConfiguracaoDetalhes />
    </div>
  );
}

export default ConfiguracaoDetalhesCabecalho;
